import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './SimCards.css';

const SimCards = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="sim-cards-page">
      <div className="sim-cards-container">
        <div className="sim-cards-content">
          <div className="sim-cards-header">
            <h1>Tarjetas SIM para Rastreadores GPS</h1>
            <p>Soluciones de conectividad confiables para tu dispositivo Distracker</p>
          </div>

          <div className="sim-cards-grid">
            <div className="sim-card">
              <div className="sim-card-header">
                <h3>Plan Básico</h3>
                <div className="sim-price">$299</div>
              </div>
              <ul className="sim-features">
                <li>1GB de datos mensuales</li>
                <li>Cobertura nacional</li>
                <li>Soporte técnico incluido</li>
                <li>Sin contratos largos</li>
              </ul>
              <button className="btn-activate-sim">Activar SIM</button>
            </div>

            <div className="sim-card featured">
              <div className="sim-card-header">
                <h3>Plan Premium</h3>
                <div className="sim-price">$499</div>
              </div>
              <ul className="sim-features">
                <li>5GB de datos mensuales</li>
                <li>Cobertura nacional e internacional</li>
                <li>Soporte técnico prioritario</li>
                <li>Alertas en tiempo real</li>
                <li>Historial ilimitado</li>
              </ul>
              <button className="btn-activate-sim">Activar SIM</button>
            </div>

            <div className="sim-card">
              <div className="sim-card-header">
                <h3>Plan Empresarial</h3>
                <div className="sim-price">$899</div>
              </div>
              <ul className="sim-features">
                <li>10GB de datos mensuales</li>
                <li>Cobertura global</li>
                <li>Soporte 24/7</li>
                <li>API para integraciones</li>
                <li>Reportes avanzados</li>
                <li>Múltiples dispositivos</li>
              </ul>
              <button className="btn-activate-sim">Activar SIM</button>
            </div>
          </div>

          <div className="sim-cards-info">
            <h3>¿Por qué elegir nuestras tarjetas SIM?</h3>
            <div className="info-grid">
              <div className="info-item">
                <h4>🔒 Seguridad</h4>
                <p>Encriptación de nivel bancario para proteger tus datos</p>
              </div>
              <div className="info-item">
                <h4>📶 Cobertura</h4>
                <p>Red confiable con 99.9% de disponibilidad</p>
              </div>
              <div className="info-item">
                <h4>💰 Precios</h4>
                <p>Planes flexibles sin costos ocultos</p>
              </div>
              <div className="info-item">
                <h4>🛠️ Soporte</h4>
                <p>Asistencia técnica especializada disponible</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimCards; 